// Client-side export helpers — CSV / XLSX / PDF
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

/**
 * @param {Object[]} rows - array of flat objects (all rows must share the same shape)
 * @param {string} name - file name without extension
 * @param {"csv"|"xlsx"|"pdf"} format
 * @param {string} [title] - optional PDF title
 */
export function exportRows(rows, name, format = "csv", title) {
  if (!rows || !rows.length) {
    // still produce empty export
    rows = [{}];
  }
  const headers = Object.keys(rows[0]);
  const filename = `${name}-${new Date().toISOString().slice(0, 10)}`;

  if (format === "csv") {
    const csv = [
      headers.join(","),
      ...rows.map(r => headers.map(h => csvEscape(r[h])).join(",")),
    ].join("\n");
    downloadBlob(csv, `${filename}.csv`, "text/csv;charset=utf-8;");
    return;
  }

  if (format === "xlsx") {
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${filename}.xlsx`);
    return;
  }

  if (format === "pdf") {
    const doc = new jsPDF({ orientation: "landscape", unit: "pt" });
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.setTextColor(30, 44, 90);
    doc.text(title || name, 40, 40);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(120);
    doc.text(`TileRoom · design your room here. · ${new Date().toLocaleString()}`, 40, 58);
    autoTable(doc, {
      startY: 80,
      head: [headers],
      body: rows.map(r => headers.map(h => formatCell(r[h]))),
      styles: { fontSize: 8, cellPadding: 4, overflow: "linebreak" },
      headStyles: { fillColor: [30, 44, 90], textColor: 255, fontStyle: "bold" },
      alternateRowStyles: { fillColor: [245, 244, 240] },
    });
    doc.save(`${filename}.pdf`);
  }
}

function csvEscape(v) {
  if (v === null || v === undefined) return "";
  const s = String(v).replace(/"/g, '""');
  return /[",\n]/.test(s) ? `"${s}"` : s;
}

function formatCell(v) {
  if (v === null || v === undefined) return "";
  if (Array.isArray(v)) return v.join(", ");
  if (typeof v === "object") return JSON.stringify(v);
  return String(v);
}

function downloadBlob(content, filename, type) {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
